import request from '@/utils/request'

export function updateProfile(data) {
  return request({ url: '/admin/profile/update', method: 'post', data })
}

export function changePassword(data) {
  return request({ url: '/admin/profile/password', method: 'post', data })
}

export function updateAvatar(data) {
  return request({ url: '/admin/profile/avatar', method: 'post', data })
}

export function uploadAvatar(data) {
  return request({ url: '/admin/profile/uploadAvatar', method: 'post', data })
}
